import angular from 'angular';
import EncodeUriFilter from '../filters/encode-uri';

class SourceInfoServ {
  constructor($filter, $sanitize, $routeParams) {
    this.encodeURI = $filter('encodeURI');
    this.sanitize = $sanitize;
    this.routeParams = $routeParams;
    this.baseUrl = window.location.protocol + "//" + window.location.hostname +
      (window.location.port ? ':' + window.location.port : '');
    this.sourceTypes = {
      file: {
        displayName: 'File',
        icon: 'icon-file',
        pluralName: 'Files'
      },
      link: {
        displayName: 'Link',
        icon: 'icon-link',
        pluralName: 'Links'
      },
      note: {
        displayName: 'Note',
        icon: 'icon-note',
        pluralName: 'Notes'
      },
      person: {
        displayName: 'Person',
        icon: 'glyphicon glyphicon-user',
        pluralName: 'People'
      },
      worksite: {
        displayName: 'iManage Doc',
        icon: 'icon-worksite',
        pluralName: 'iManage Docs'
      },
      box: {
        displayName: 'Box File',
        icon: 'icon-box',
        pluralName: 'Box Files',
        integration: true
      },
      dropbox: {
        displayName: 'Dropbox',
        icon: 'icon-dropbox',
        pluralName: 'Dropbox',
        integration: true
      },
      clio: {
        displayName: 'Clio',
        icon: 'icon-clio',
        pluralName: 'Clio',
        integration: true
      }
    };
  };

  getLink(s, caseId = this.routeParams.caseId) {
    if (!s) {
      return;
    }
    s.bookmarksEnabled = /\.pdf$/.test(s.url) && /^(file|link|box|dropbox|clio)$/.test(
      s.format);
    if (/^(file|worksite|box|dropbox|clio)$/.test(s.format)) {
      s.link = this.sanitize(this.baseUrl + '/case/' + caseId + '/upload/' +
        s.id + '/' +
        this.encodeURI(s.displayName));
    } else if (/^link$/.test(s.format)) {
      s.link = this.sanitize(s.url);
    }
    return s;
  };

}

SourceInfoServ.$inject = ['$filter', '$sanitize', '$routeParams'];

export default angular.module('services.source-info', [EncodeUriFilter])
  .service('SourceInfoServ', SourceInfoServ)
  .name;



// WEBPACK FOOTER //
// ./project/services/source-info.js